import { render, staticRenderFns } from "./TeacherIntroNew.vue?vue&type=template&id=72fc3372&scoped=true&"
import script from "./TeacherIntroNew.vue?vue&type=script&lang=js&"
export * from "./TeacherIntroNew.vue?vue&type=script&lang=js&"
import style0 from "./TeacherIntroNew.vue?vue&type=style&index=0&id=72fc3372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc3372",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VRow})
